import { render } from "./MedioCom_MedioPers.vue?vue&type=template&id=0715bfc6"
import script from "./MedioCom_MedioPers.vue?vue&type=script&lang=js"
export * from "./MedioCom_MedioPers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__